module.exports = __webpack_public_path__ + "img/leftarrow.cecdb3c5.svg";